var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscoverHomeBannerNative = function SvgDiscoverHomeBannerNative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 160,
    rx: 10,
    fill: "url(#Discover_Home_Banner_Native_svg__a)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#Discover_Home_Banner_Native_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M20.768-70.01V86.513l35.093 28.255v38.269l23.8 20.017v44.045",
    stroke: "url(#Discover_Home_Banner_Native_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M24.15-71.64V84.883l35.096 28.255v38.269l23.797 20.017v44.046",
    stroke: "url(#Discover_Home_Banner_Native_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M27.532-73.27V83.253l35.096 28.252v38.269l23.797 20.02v44.046",
    stroke: "url(#Discover_Home_Banner_Native_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M30.918-74.9V81.62l35.093 28.255v38.269l23.797 20.02v44.043",
    stroke: "url(#Discover_Home_Banner_Native_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M34.3-76.533V79.991l35.094 28.254v38.27l23.797 20.016v44.046",
    stroke: "url(#Discover_Home_Banner_Native_svg__g)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M37.683-78.163V78.361l35.093 28.254v38.27l23.797 20.017v44.045",
    stroke: "url(#Discover_Home_Banner_Native_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M41.065-79.793V76.731l35.094 28.251v38.27l23.8 20.02v44.045",
    stroke: "url(#Discover_Home_Banner_Native_svg__i)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M44.448-72.76V75.102l35.093 28.252v38.269l23.8 20.02v44.045",
    stroke: "url(#Discover_Home_Banner_Native_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M47.831-74.9V73.468l35.093 28.255v38.269l23.8 20.02v44.042",
    stroke: "url(#Discover_Home_Banner_Native_svg__k)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M51.213-69.494V71.838l35.096 28.255v38.269l23.797 20.017v44.046",
    stroke: "url(#Discover_Home_Banner_Native_svg__l)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.576 116.533a.89.89 0 1 1 1.262-1.257.89.89 0 0 1-1.262 1.257Z",
    fill: "#B8B8B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.576 121.459a.89.89 0 1 1 1.262-1.257.89.89 0 0 1-1.262 1.257Z",
    stroke: "#B8B8B8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.576 126.388a.893.893 0 0 1 .003-1.26.892.892 0 0 1 1.259.003.89.89 0 1 1-1.262 1.257Z",
    fill: "#B8B8B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.576 131.317a.89.89 0 1 1 1.262-1.255.89.89 0 0 1-1.262 1.255Z",
    stroke: "#B8B8B8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.576 136.244a.89.89 0 1 1 1.262-1.257.89.89 0 0 1-1.262 1.257ZM14.576 141.173a.893.893 0 0 1 .003-1.26.892.892 0 0 1 1.259.003.89.89 0 1 1-1.262 1.257Z",
    fill: "#B8B8B8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.576 146.102a.89.89 0 1 1 1.262-1.255.89.89 0 0 1-1.262 1.255ZM14.576 151.032a.89.89 0 1 1 1.262-1.257.89.89 0 0 1-1.262 1.257Z",
    stroke: "#B8B8B8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.576 155.958a.89.89 0 1 1 1.262-1.257.89.89 0 0 1-1.262 1.257ZM19.553 121.511a.89.89 0 1 1 1.262-1.257.89.89 0 0 1-1.261 1.257Z",
    fill: "#B8B8B8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.553 126.44a.893.893 0 0 1 .004-1.26.892.892 0 0 1 1.259.003.89.89 0 1 1-1.262 1.257Z",
    stroke: "#B8B8B8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.553 131.367a.89.89 0 1 1 1.262-1.257.89.89 0 0 1-1.261 1.257Z",
    fill: "#B8B8B8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M19.553 136.296a.89.89 0 1 1 1.262-1.257.89.89 0 0 1-1.261 1.257Z",
    stroke: "#B8B8B8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M19.553 141.225a.893.893 0 0 1 .004-1.26.892.892 0 0 1 1.259.003.89.89 0 1 1-1.262 1.257ZM19.553 146.154a.89.89 0 1 1 1.262-1.255.89.89 0 0 1-1.261 1.255Z",
    fill: "#B8B8B8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.553 151.081a.89.89 0 1 1 1.262-1.257.89.89 0 0 1-1.261 1.257ZM19.553 156.01a.89.89 0 1 1 1.262-1.257.89.89 0 0 1-1.261 1.257Z",
    stroke: "#B8B8B8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.198 159.829a.893.893 0 0 1 .003-1.26.892.892 0 0 1 1.259.003.89.89 0 1 1-1.262 1.257ZM30.114 139.65a.893.893 0 0 1 .003-1.26.892.892 0 0 1 1.259.003.89.89 0 1 1-1.262 1.257ZM30.114 144.58a.89.89 0 1 1 1.262-1.257.89.89 0 0 1-1.262 1.257Z",
    fill: "#B8B8B8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.114 149.509a.89.89 0 1 1 1.262-1.257.89.89 0 0 1-1.262 1.257ZM30.114 154.438a.893.893 0 0 1 .003-1.26.892.892 0 0 1 1.259.003.89.89 0 1 1-1.262 1.257Z",
    stroke: "#B8B8B8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.114 159.364a.891.891 0 1 1 1.261-1.254.891.891 0 0 1-1.261 1.254Z",
    fill: "#B8B8B8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.742 133.831a.893.893 0 0 1 .003-1.26.892.892 0 0 1 1.259.003.89.89 0 1 1-1.262 1.257Z",
    stroke: "#B8B8B8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.742 138.761a.89.89 0 1 1 1.262-1.257.89.89 0 0 1-1.262 1.257ZM24.742 143.69a.89.89 0 1 1 1.262-1.257.89.89 0 0 1-1.262 1.257Z",
    fill: "#B8B8B8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.742 148.616a.893.893 0 0 1 .003-1.26.892.892 0 0 1 1.259.003.89.89 0 1 1-1.262 1.257ZM24.742 153.545a.893.893 0 0 1 .003-1.26.892.892 0 0 1 1.259.003.89.89 0 1 1-1.262 1.257Z",
    stroke: "#B8B8B8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.742 158.475a.89.89 0 1 1 1.262-1.257.89.89 0 0 1-1.262 1.257Z",
    fill: "#B8B8B8"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M179.344 61.944a1.463 1.463 0 0 0-1.561-1.354 1.464 1.464 0 0 0-1.354 1.562c.058.804.755 1.41 1.562 1.355a1.464 1.464 0 0 0 1.353-1.563Z",
    fill: "url(#Discover_Home_Banner_Native_svg__m)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M199.077 50.633a2.416 2.416 0 0 0-2.579-2.238 2.416 2.416 0 0 0 .342 4.82 2.417 2.417 0 0 0 2.237-2.582Z",
    fill: "url(#Discover_Home_Banner_Native_svg__n)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M343.327 101.143a1.389 1.389 0 0 0-1.482-1.287 1.389 1.389 0 1 0 1.482 1.287Z",
    fill: "url(#Discover_Home_Banner_Native_svg__o)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M332.309 45.294a2.293 2.293 0 1 0-4.574.327 2.292 2.292 0 1 0 4.574-.327Z",
    fill: "url(#Discover_Home_Banner_Native_svg__p)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M167.749 18.733a2.416 2.416 0 0 1-2.579 2.239 2.415 2.415 0 0 1 .342-4.82 2.417 2.417 0 0 1 2.237 2.581Z",
    fill: "url(#Discover_Home_Banner_Native_svg__q)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M167.749 37.478a2.416 2.416 0 0 0-2.579-2.238 2.415 2.415 0 0 0 .342 4.819 2.417 2.417 0 0 0 2.237-2.58Z",
    fill: "url(#Discover_Home_Banner_Native_svg__r)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M32.032 105.203a4.832 4.832 0 0 0 2.613-6.312 4.827 4.827 0 0 0-6.308-2.615 4.833 4.833 0 0 0-2.613 6.313 4.826 4.826 0 0 0 6.308 2.614Z",
    fill: "url(#Discover_Home_Banner_Native_svg__s)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M40.747 128.639a4.83 4.83 0 0 0 4.828-4.831 4.83 4.83 0 0 0-4.828-4.831 4.83 4.83 0 0 0-4.828 4.831 4.83 4.83 0 0 0 4.828 4.831Z",
    fill: "url(#Discover_Home_Banner_Native_svg__t)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M25.209 130.214a4.83 4.83 0 0 0 4.828-4.831 4.83 4.83 0 0 0-4.828-4.831 4.83 4.83 0 0 0-4.828 4.831 4.83 4.83 0 0 0 4.828 4.831Z",
    fill: "url(#Discover_Home_Banner_Native_svg__u)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Discover_Home_Banner_Native_svg__v)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.142 159.781s-24.326-26.156-4.114-54.473c17.934-25.125 38.843-23.408 54.184-13.212 6.533 4.343 25.371.535 41.405-25.03 21.864-34.864 97.656-13.72 83.838 39.921-6.688 25.958 20.353 26.902 6.574 52.849l-181.887-.055Z",
    fill: "url(#Discover_Home_Banner_Native_svg__w)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.119 131.884 1.866.307c.149.024.28.087.384.174.109.091.187.21.22.34a.54.54 0 0 1 .012.235l-4.293 26.055c-.056.336-.405.563-.786.517a.47.47 0 0 1-.037-.005l-1.866-.307-.037-.007c-.376-.079-.634-.406-.578-.742l4.293-26.055a.557.557 0 0 1 .085-.219.67.67 0 0 1 .318-.251.783.783 0 0 1 .419-.042Z",
    fill: "#FFB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.597 145.104-2.3 13.959c-.049.3-.394.496-.775.449a.47.47 0 0 1-.037-.005l-1.866-.307-.037-.007c-.377-.077-.639-.374-.59-.674l2.018-12.245c1.005-.035 2.425-.269 3.586-1.17h.001ZM264.87 134.927l-.049.296 3.304.546.049-.296-3.304-.546ZM264.72 135.943l-.049.296 3.304.546.048-.296-3.303-.546ZM264.51 137.133l-.049.296 3.304.546.048-.296-3.303-.546ZM264.213 138.983l-.049.296 3.304.546.048-.296-3.303-.546ZM263.89 140.93l-.049.296 3.303.546.049-.296-3.303-.546ZM263.402 143.921l-.048.296 3.303.546.049-.296-3.304-.546Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.93 146.705-.049.296 3.303.546.049-.296-3.303-.546ZM262.528 149.213l-.049.296 3.304.546.049-.296-3.304-.546ZM265.04 133.985l-.049.296 3.304.545.049-.296-3.304-.545ZM265.139 133.349l-.049.296 3.303.546.049-.296-3.303-.546ZM265.243 132.746l-.049.296 3.304.546.049-.296-3.304-.546ZM265.266 132.58l3.304.545.031-.186a.54.54 0 0 0 .006-.113l-3.281-.54a.566.566 0 0 0-.03.109l-.03.185ZM265.383 132.177l3.207.528a.669.669 0 0 0-.221-.34l-2.669-.44a.67.67 0 0 0-.318.251l.001.001Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.506 131.883 1.866.308c.149.024.28.087.384.174a.62.62 0 0 1 .231.574l-4.293 26.056c-.055.335-.404.563-.785.517a.47.47 0 0 1-.037-.005l-1.866-.308-.038-.006c-.375-.079-.633-.406-.578-.742l4.293-26.056a.561.561 0 0 1 .086-.218.659.659 0 0 1 .318-.251.793.793 0 0 1 .419-.043Z",
    fill: "#FFB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.983 145.104-2.3 13.959c-.05.3-.394.496-.775.449l-.038-.005-1.865-.308-.038-.006c-.376-.078-.638-.374-.589-.674l2.018-12.245c1.005-.036 2.425-.269 3.586-1.17h.001ZM268.255 134.926l-.049.296 3.304.547.048-.296-3.303-.547ZM268.109 135.946l-.048.296 3.303.545.049-.296-3.304-.545ZM267.893 137.132l-.048.296 3.303.546.049-.296-3.304-.546ZM267.596 138.98l-.049.296 3.304.546.048-.296-3.303-.546ZM267.275 140.929l-.048.296 3.303.546.049-.296-3.304-.546ZM266.778 143.911l-.049.296 3.304.546.049-.296-3.304-.546Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.321 146.712-.049.296 3.304.546.049-.296-3.304-.546ZM265.911 149.21l-.049.296 3.304.546.049-.296-3.304-.546ZM268.415 133.975l-.049.296 3.304.546.049-.296-3.304-.546ZM268.534 133.359l-.049.296 3.304.545.049-.296-3.304-.545ZM268.629 132.746l-.049.296 3.304.545.049-.296-3.304-.545ZM268.653 132.58l3.304.544.031-.185a.54.54 0 0 0 .006-.113l-3.281-.54a.502.502 0 0 0-.03.109l-.031.185h.001ZM268.769 132.177l3.207.528a.67.67 0 0 0-.22-.341l-2.669-.439a.659.659 0 0 0-.318.251v.001Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.124 156.898-.003 1.893c0 .151-.04.291-.11.408a.664.664 0 0 1-.299.272.53.53 0 0 1-.117.037.526.526 0 0 1-.112.012l-26.371-.063c-.34 0-.619-.31-.636-.694v-.037l.003-1.894v-.037c.018-.384.299-.691.638-.691l26.371.064a.542.542 0 0 1 .23.05.666.666 0 0 1 .298.274.798.798 0 0 1 .109.407l-.001-.001Z",
    fill: "#FFB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.171 159.491-14.128-.034c-.303 0-.553-.31-.567-.694v-.037l.003-1.894v-.037c.016-.384.266-.691.57-.691l12.393.03c.196.988.655 2.353 1.728 3.357h.001ZM253.629 156.168l-.008 3.353.3.001.008-3.353-.3-.001ZM252.613 156.165l-.009 3.353.3.001.008-3.353-.299-.001ZM251.386 156.152l-.009 3.353.3.001.008-3.353-.299-.001ZM249.515 156.143l-.007 3.353.299.001.008-3.353-.3-.001ZM247.56 156.154l-.008 3.353.299.001.008-3.353-.299-.001ZM244.537 156.146l-.009 3.354h.3l.008-3.353-.299-.001Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.706 156.14-.008 3.353.3.001.008-3.353-.3-.001ZM239.171 156.126l-.009 3.353.3.001.008-3.353-.299-.001ZM254.593 156.171l-.008 3.353.3.001.008-3.353-.3-.001ZM255.223 156.163l-.007 3.353.299.001.007-3.353-.299-.001ZM255.848 156.173l-.008 3.353.299.001.009-3.353-.3-.001ZM256.301 156.166l-.006 3.353h.187a.513.513 0 0 0 .112-.011l.007-3.33a.52.52 0 0 0-.112-.012h-.188ZM256.718 156.216l-.006 3.256a.656.656 0 0 0 .299-.273l.005-2.709a.678.678 0 0 0-.298-.274Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.313 153.539-.003 1.893a.802.802 0 0 1-.11.408.672.672 0 0 1-.3.272.515.515 0 0 1-.117.037.52.52 0 0 1-.112.012l-26.371-.063c-.34 0-.619-.31-.636-.694v-.037l.003-1.894v-.037c.018-.384.299-.691.639-.691l26.371.063c.017 0 .034.001.05.003l.022.002c.008 0 .016.003.023.004.006 0 .011.002.017.003a.525.525 0 0 1 .133.046l.016.008.033.018.018.012c.006.004.011.006.016.011a.232.232 0 0 1 .03.022l.033.028a.578.578 0 0 0 .027.025l.016.017a.609.609 0 0 1 .046.055l.013.016.012.018.024.037a.817.817 0 0 1 .109.408l-.002-.002Z",
    fill: "#FFB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.358 156.13-14.128-.034c-.304 0-.553-.309-.568-.693v-.037l.003-1.894v-.037c.016-.384.267-.692.57-.692l12.392.03.017.083c.206.98.668 2.299 1.712 3.274h.002ZM250.799 152.792l-.008 3.353.3.001.007-3.353-.299-.001ZM249.785 152.79l-.008 3.353.3.001.007-3.353-.299-.001ZM248.583 152.802l-.008 3.353.3.001.008-3.353-.3-.001ZM246.719 152.798l-.008 3.353.299.001.009-3.353-.3-.001ZM244.737 152.784l-.007 3.353.3.001.007-3.353-.3-.001ZM241.717 152.779l-.009 3.353.3.001.008-3.353-.299-.001Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.892 152.779-.008 3.353h.299l.009-3.353h-.3ZM236.357 152.765l-.007 3.353h.299l.007-3.353h-.299ZM251.764 152.794l-.007 3.353.299.001.008-3.353-.3-.001ZM252.418 152.811l-.008 3.353.3.001.008-3.353-.3-.001ZM253.036 152.812l-.009 3.354h.3l.008-3.353-.299-.001ZM253.489 152.806l-.007 3.353h.188a.52.52 0 0 0 .112-.012l.006-3.329a.52.52 0 0 0-.112-.012h-.187ZM253.905 152.857l-.006 3.254a.658.658 0 0 0 .3-.273l.005-2.708a.674.674 0 0 0-.299-.274v.001Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.68 150.271-.003 1.893a.79.79 0 0 1-.11.408.669.669 0 0 1-.299.272.602.602 0 0 1-.23.049l-26.371-.063a.567.567 0 0 1-.293-.084.738.738 0 0 1-.34-.578l-.003-.032v-.037l.003-1.894v-.037c.018-.384.299-.691.639-.69l26.371.062a.534.534 0 0 1 .229.05.668.668 0 0 1 .299.274.789.789 0 0 1 .108.408v-.001Z",
    fill: "#FFB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.727 152.863-14.128-.034a.476.476 0 0 1-.263-.083c-.166-.113-.285-.328-.303-.578l-.003-.032v-.037l.003-1.894v-.037c.017-.384.267-.691.571-.69l12.392.029c.191.96.63 2.279 1.643 3.274l.086.084.002-.002Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.319 146.918-.003 1.894a.802.802 0 0 1-.11.408.666.666 0 0 1-.3.272.6.6 0 0 1-.229.049l-26.371-.064c-.34 0-.619-.309-.636-.693v-.037l.003-1.894v-.037c.016-.356.258-.645.563-.686a.633.633 0 0 1 .076-.005l26.371.063a.526.526 0 0 1 .229.05.671.671 0 0 1 .299.275.797.797 0 0 1 .108.407v-.002Z",
    fill: "#FFB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m243.365 149.512-14.128-.034c-.304 0-.554-.31-.568-.694v-.037l.003-1.894v-.037c.015-.355.23-.645.503-.686a.504.504 0 0 1 .067-.005l12.393.03.001.005c.197.987.656 2.351 1.728 3.352h.001Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.386 143.565-.003 1.894a.802.802 0 0 1-.11.408.672.672 0 0 1-.3.272.515.515 0 0 1-.117.037l-.037.007a.165.165 0 0 0-.021.002.125.125 0 0 1-.021.002l-.034.001-26.37-.063c-.34-.001-.62-.31-.637-.694v-.037l.004-1.894v-.037l.001-.031c.026-.309.223-.563.48-.638.006-.002.013-.003.019-.006a.58.58 0 0 1 .138-.017l26.371.064a.53.53 0 0 1 .057.003l.026.003.03.006c.04.008.079.021.117.038a.663.663 0 0 1 .299.274.808.808 0 0 1 .109.407l-.001-.001Z",
    fill: "#FFB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.432 146.158-14.128-.033c-.304 0-.553-.31-.568-.694v-.037l.004-1.894v-.037l.001-.031c.024-.316.207-.574.443-.643a.481.481 0 0 1 .126-.018l12.392.03.005.024c.199.984.658 2.333 1.719 3.329l.005.004h.001Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.334 140.236-.003 1.894c0 .151-.04.291-.11.407a.664.664 0 0 1-.3.273.574.574 0 0 1-.091.031l-.025.006a.607.607 0 0 1-.112.011l-26.371-.062a.569.569 0 0 1-.083-.007c-.01 0-.021-.003-.031-.005-.287-.06-.508-.342-.522-.682v-.037l.003-1.894v-.037c.018-.384.299-.691.638-.69l26.371.063a.41.41 0 0 1 .05.002c.008 0 .015.002.022.003.008 0 .016.002.023.004.006 0 .012.002.017.003.041.008.08.021.117.038l.017.008.017.008.032.018.035.022.029.022c.012.009.022.019.033.029a.18.18 0 0 1 .026.025.815.815 0 0 1 .063.071l.013.017.012.018.023.037a.788.788 0 0 1 .108.407l-.001-.003Z",
    fill: "#FFB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.381 142.829-14.128-.034c-.011 0-.022 0-.034-.002-.012 0-.024-.002-.036-.004-.271-.044-.485-.334-.497-.689v-.037l.003-1.893v-.038c.016-.384.266-.691.57-.691l12.392.029.017.083c.203.972.66 2.277 1.687 3.251l.025.023.001.002Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.705 136.969-.004 1.893c0 .152-.04.291-.109.408a.672.672 0 0 1-.3.272.593.593 0 0 1-.229.049l-26.371-.063a.568.568 0 0 1-.294-.084.74.74 0 0 1-.342-.61v-.037l.003-1.894v-.037c.018-.384.299-.691.639-.69l26.37.062a.529.529 0 0 1 .23.05.656.656 0 0 1 .298.274.799.799 0 0 1 .109.408v-.001Z",
    fill: "#FFB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.75 139.562-14.128-.033a.469.469 0 0 1-.262-.084c-.167-.112-.285-.326-.304-.577l-.002-.032v-.038l.003-1.893v-.037c.016-.384.267-.692.57-.692l12.393.029c.19.961.63 2.28 1.642 3.275.028.027.057.056.087.082h.001Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.867 133.621-.004 1.893c0 .151-.04.291-.109.408a.672.672 0 0 1-.3.272.53.53 0 0 1-.117.037.52.52 0 0 1-.112.012l-26.371-.063c-.34 0-.619-.31-.636-.694v-.037l.003-1.894v-.037c.016-.355.258-.645.563-.686a.63.63 0 0 1 .075-.005l26.371.063c.038 0 .076.004.112.013.04.008.079.021.116.038a.663.663 0 0 1 .299.274.797.797 0 0 1 .108.407l.002-.001Z",
    fill: "#FFB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.912 136.214-14.128-.034c-.303 0-.553-.31-.567-.694v-.037l.003-1.894v-.037c.015-.355.23-.645.503-.686a.491.491 0 0 1 .067-.005l12.393.029.001.006c.197.987.655 2.351 1.728 3.352Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.411 130.264-.004 1.894c0 .151-.04.291-.109.407a.674.674 0 0 1-.3.273.53.53 0 0 1-.117.037l-.037.006-.03.004-.015.001h-.03l-26.371-.063c-.34 0-.619-.31-.636-.694v-.037l.003-1.893v-.038c.018-.384.299-.691.639-.69l26.37.063c.012 0 .023 0 .034.002a.502.502 0 0 1 .196.048.706.706 0 0 1 .055.028l.033.021s.002 0 .003.002c.01.007.022.015.032.024.003 0 .004.002.006.004a.484.484 0 0 1 .11.109l.003.004.011.014.003.003c.006.008.013.017.018.026a.789.789 0 0 1 .133.448v-.003Z",
    fill: "#FFB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.455 132.857-14.128-.034c-.303 0-.553-.309-.567-.693v-.038l.003-1.893v-.037c.016-.385.267-.692.57-.692l12.393.03.016.078c.204.979.665 2.298 1.707 3.274l.006.006v-.001Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.355 126.993-.003 1.893a.8.8 0 0 1-.11.408.672.672 0 0 1-.3.272.572.572 0 0 1-.229.049l-26.371-.063a.566.566 0 0 1-.285-.079.738.738 0 0 1-.349-.586l-.002-.03v-.037l.003-1.894v-.037c.016-.356.258-.645.563-.685a.477.477 0 0 1 .076-.005l26.371.063a.52.52 0 0 1 .229.05.668.668 0 0 1 .299.274.798.798 0 0 1 .108.408v-.001Z",
    fill: "#FFB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m243.4 129.586-14.128-.034a.464.464 0 0 1-.255-.078c-.171-.111-.294-.33-.311-.586l-.002-.03v-.037l.003-1.894v-.037c.015-.355.23-.645.503-.685a.378.378 0 0 1 .067-.005l12.393.029.001.005c.191.963.632 2.281 1.647 3.275l.081.078.001-.001Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.421 123.641-.003 1.893c0 .151-.04.291-.11.408a.664.664 0 0 1-.299.272.548.548 0 0 1-.117.037l-.038.007-.021.002-.021.002-.034.001-26.37-.063c-.34 0-.62-.31-.637-.694v-.037l.004-1.894v-.037c.017-.384.298-.691.638-.691l26.371.063c.039 0 .076.005.112.013a.534.534 0 0 1 .117.038.663.663 0 0 1 .299.274.798.798 0 0 1 .109.407v-.001Z",
    fill: "#FFB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.468 126.233-14.128-.033c-.304 0-.553-.31-.568-.694v-.037l.004-1.894v-.037c.016-.384.266-.691.57-.691l12.393.03c.195.986.653 2.348 1.723 3.352l.005.005.001-.001ZM252.183 149.54l-.008 3.353h.299l.009-3.353h-.3ZM251.159 149.53l-.007 3.353h.3l.007-3.353h-.3ZM249.94 149.524l-.007 3.353h.299l.007-3.353h-.299ZM248.087 149.53l-.008 3.353.3.001.008-3.353-.3-.001ZM246.116 149.526l-.009 3.353.3.001.008-3.353-.299-.001ZM243.091 149.519l-.008 3.353.3.001.008-3.353-.3-.001ZM240.252 149.503l-.007 3.353.3.001.007-3.353-.3-.001ZM237.734 149.506l-.008 3.353h.299l.008-3.353h-.299ZM253.15 149.542l-.008 3.353.299.001.008-3.353-.299-.001ZM253.777 149.536l-.007 3.353.299.001.007-3.353-.299-.001ZM254.404 149.545l-.008 3.353.299.001.008-3.353-.299-.001ZM254.857 149.538l-.005 3.353h.187a.513.513 0 0 0 .112-.011l.007-3.33a.535.535 0 0 0-.113-.012h-.188ZM255.273 149.588l-.005 3.256a.672.672 0 0 0 .299-.273l.005-2.709a.68.68 0 0 0-.299-.274ZM243.73 146.167l-.008 3.353h.299l.008-3.353h-.299ZM240.883 146.145l-.008 3.353.3.001.007-3.353-.299-.001ZM238.37 146.153l-.008 3.353.3.001.008-3.353-.3-.001Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.07 149.537.007-3.353h-.263c.013-.003.028-.004.042-.008l.006-3.329a.503.503 0 0 0-.056-.009l.006-3.25h.117l-.006 3.222a.663.663 0 0 0 .3-.273l.005-2.708a.679.679 0 0 0-.238-.241h.105l.007-3.353h-.3l-.005 3.279a.512.512 0 0 0-.096-.009h-.188l-.006 3.353h.056l-.007 3.33h.187l.034-.001-.006 3.35h.299ZM254.425 146.191l-.008 3.353.3.001.008-3.353-.3-.001ZM255.033 146.186l-.009 3.353.3.001.009-3.353-.3-.001ZM255.495 146.187l-.007 3.353h.188a.525.525 0 0 0 .112-.011l.005-3.33a.52.52 0 0 0-.112-.012h-.187.001ZM255.91 146.237l-.006 3.255a.661.661 0 0 0 .3-.272l.005-2.709a.674.674 0 0 0-.299-.274ZM251.173 146.182l.006-3.354h-.056l.007-3.329h-.3l-.006 3.353h.056l-.007 3.323h-.292l-.006 3.354h.3l.005-3.348.293.001ZM248.948 142.824h-.056l.007-3.33-.301-.001-.005 3.353h.055l-.006 3.33h.074l-.006 3.348.299.001.007-3.353h-.074l.006-3.348Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.978 142.884-.005 3.255a.659.659 0 0 0 .299-.272l.005-2.709a.674.674 0 0 0-.299-.274ZM247.034 139.489h-.3l-.006 3.353h.055l-.006 3.324h-.033l-.006 3.353.3.001.005-3.349.034.001.006-3.354h-.056l.007-3.329ZM245.062 139.485l-.3-.001-.006 3.353h.056l-.007 3.33h.3l.006-3.354h-.056l.007-3.328ZM242.038 139.478l-.3-.001-.006 3.353h.055l-.005 3.329.299.001.006-3.353-.055-.001.006-3.328ZM239.207 139.47l-.3-.001-.006 3.354h.056l-.006 3.33.299.001.007-3.354h-.056l.006-3.33ZM236.68 139.465l-.3-.001-.006 3.353.056.001-.006 3.328.3.001.005-3.353h-.055l.006-3.329ZM252.095 139.501l-.299-.001-.007 3.354h.056l-.007 3.324h-.041l-.006 3.353.3.001.006-3.348h.042l.005-3.353h-.055l.006-3.33ZM252.733 139.503l-.241-.001.006-3.271h-.299l-.007 3.353.242.001-.007 3.271h.056l-.006 3.328.3.001.006-3.353h-.055l.005-3.329ZM251.193 136.235l-.008 3.353.299.001.008-3.353-.299-.001ZM249.961 139.496h-.146l-.005 3.353h.054l-.005 3.33.299.001.007-3.354h-.056l.006-3.247h.146l.006-3.353h-.3l-.006 3.27ZM248.102 136.22l-.009 3.353.299.001.009-3.353-.299-.001ZM246.139 136.224l-.008 3.353h.299l.009-3.353h-.3ZM243.099 136.204l-.007 3.353h.299l.008-3.353h-.3ZM240.272 136.199l-.007 3.353.299.001.007-3.353-.299-.001ZM237.758 136.203l-.008 3.353.3.001.008-3.353-.3-.001ZM253.158 139.503h-.108l-.007 3.354h.056l-.006 3.324-.281-.001-.006 3.353.299.001.007-3.348.281.001.005-3.353h-.055l.006-3.247.108.001.007-3.354-.3-.001-.006 3.27ZM254.427 136.243l-.008 3.353.299.001.009-3.353-.3-.001ZM255.176 139.579l.006-3.329a.52.52 0 0 0-.112-.012h-.188l-.006 3.353h.187a.529.529 0 0 0 .113-.012ZM255.593 139.27l.004-2.709a.667.667 0 0 0-.298-.274l-.006 3.255a.661.661 0 0 0 .3-.272ZM254.369 132.889l-.009 3.353.3.001.008-3.353-.299-.001Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.274 132.879-.008 3.353.299.001.008-3.353-.299-.001ZM248.301 132.875l-.008 3.353h.3l.008-3.353h-.3ZM245.278 132.867l-.008 3.353.299.001.008-3.353-.299-.001ZM242.446 132.861l-.008 3.353.299.001.008-3.353-.299-.001ZM239.909 132.848l-.007 3.353.3.001.007-3.353-.3-.001ZM255.334 132.891l-.008 3.353.3.001.008-3.353-.3-.001ZM255.973 132.893l-.008 3.353h.299l.009-3.353h-.3ZM256.57 132.882l-.008 3.353h.3l.008-3.353h-.3ZM257.042 132.889l-.006 3.353h.187a.529.529 0 0 0 .113-.012l.006-3.329a.59.59 0 0 0-.112-.012h-.188ZM257.459 132.939l-.006 3.255a.667.667 0 0 0 .3-.272l.005-2.709a.674.674 0 0 0-.299-.274ZM250.897 132.88l.3.001.006-3.354-.292-.001.006-3.271.292.001.006-3.353-.299-.001-.007 3.349-.292-.001-.006 3.353.293.001-.007 3.276ZM249.888 129.523l-.009 3.353.299.001.009-3.354h-.299ZM244.844 129.518l-.008 3.353.3.001.008-3.353-.3-.001ZM241.805 129.499l-.007 3.353.299.001.008-3.353-.3-.001ZM238.99 129.503l-.009 3.353.3.001.008-3.353-.299-.001ZM236.447 129.486l-.008 3.353.3.001.008-3.353-.3-.001ZM251.863 132.882h.265l-.006 3.348.3.001.006-3.353-.265-.001.006-3.348h-.041l.005-3.27h.041l.007-3.353-.3-.001-.006 3.348-.041-.001-.007 3.354h.042l-.006 3.276ZM252.517 129.538l-.006 3.353h.299l.007-3.353h-.3ZM254.055 129.611h.052l.006-3.353h-.263l.042-.007.007-3.33a.535.535 0 0 0-.113-.012h-.187l-.006 3.353h.187c.011 0 .023 0 .034-.002l-.006 3.275-.034-.002h-.187l-.006 3.348h-.164l.006-3.348h-.281l.006-3.272h.281l.006-3.352h-.299l-.007 3.347h-.281l-.006 3.353h.281l-.006 3.276h.228l-.007 3.349h.3l.006-3.348h.123a.513.513 0 0 0 .112-.011l.006-3.264h.117l-.006 3.227a.658.658 0 0 0 .3-.273l.005-2.708a.685.685 0 0 0-.247-.246h.001ZM243.756 126.233l-.007 3.353.3.001.007-3.353-.3-.001ZM240.935 126.233l-.008 3.353.299.001.008-3.353-.299-.001ZM238.407 126.227l-.009 3.353.3.001.008-3.353-.299-.001ZM254.444 126.253l-.007 3.353h.299l.008-3.353h-.3ZM255.078 126.267l-.009 3.353h.3l.008-3.353h-.299ZM255.531 126.261l-.007 3.353h.188a.519.519 0 0 0 .112-.011l.006-3.33a.535.535 0 0 0-.113-.012h-.187.001ZM256.241 129.294l.005-2.708a.674.674 0 0 0-.299-.274l-.006 3.255a.663.663 0 0 0 .3-.273ZM249.909 122.906l-.009 3.353.3.001.008-3.353-.299-.001ZM248.984 122.898l-.3-.001-.006 3.354h.074l-.006 3.27h-.074l-.006 3.353.3.001.005-3.276.074.001.007-3.354h-.074l.006-3.348ZM246.813 126.241h-.033l-.006 3.353h.034l-.007 3.276.3.001.006-3.354h-.033l.006-3.27h.033l.006-3.353-.299-.001-.007 3.348ZM244.857 122.894l-.008 3.353.299.001.008-3.353-.299-.001ZM241.833 122.886l-.008 3.354h.3l.008-3.353-.3-.001ZM238.995 122.874l-.009 3.353.3.001.009-3.353-.3-.001ZM236.467 122.868l-.007 3.353h.3l.007-3.353h-.3ZM252.518 122.904l-.009 3.353.299.001.009-3.353-.299-.001Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.015 122.959-.005 3.255a.659.659 0 0 0 .299-.272l.005-2.709a.674.674 0 0 0-.299-.274Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.801 131.899 1.862.331c.149.026.279.09.381.178a.667.667 0 0 1 .216.343.56.56 0 0 1 .009.235l-4.626 25.998c-.06.335-.412.557-.792.506a.47.47 0 0 1-.037-.005l-1.862-.332-.037-.007c-.375-.084-.629-.414-.57-.749l4.626-25.998a.733.733 0 0 1 .026-.093l.006-.017a.562.562 0 0 1 .058-.108l.01-.015a.311.311 0 0 1 .034-.043l.015-.016.013-.014.027-.026a.392.392 0 0 1 .033-.027l.027-.021h.001l.02-.013a.897.897 0 0 1 .061-.037l.019-.009c.006-.004.013-.006.019-.009a.798.798 0 0 1 .46-.054l.001.002Z",
    fill: "#FFB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.109 145.124-2.477 13.928c-.054.299-.4.492-.781.44a.238.238 0 0 1-.037-.006l-1.862-.331-.037-.007c-.375-.083-.634-.383-.581-.683l2.174-12.217.084-.002c1-.033 2.377-.261 3.517-1.122ZM261.521 134.932l-.052.295 3.296.589.053-.295-3.297-.589ZM261.341 135.931l-.053.296 3.297.587.052-.295-3.296-.588ZM261.122 137.125l-.053.296 3.297.588.052-.296-3.296-.588ZM260.796 138.964l-.053.295 3.297.588.052-.295-3.296-.588ZM260.453 140.913l-.053.295 3.297.588.052-.296-3.296-.587ZM259.935 143.905l-.052.295 3.296.589.053-.296-3.297-.588Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.427 146.684-.053.295 3.297.587.052-.295-3.296-.587ZM258.991 149.182l-.053.295 3.297.589.052-.295-3.296-.589ZM261.682 133.974l-.052.296 3.296.588.053-.296-3.297-.588ZM261.811 133.361l-.052.295 3.296.589.053-.296-3.297-.588ZM261.903 132.738l-.052.295 3.296.588.053-.295-3.297-.588ZM261.939 132.585l3.297.586.033-.184a.547.547 0 0 0 .008-.114l-3.274-.582a.568.568 0 0 0-.031.109l-.034.185h.001ZM262.062 132.183l3.2.569a.661.661 0 0 0-.216-.343l-2.663-.474a.665.665 0 0 0-.321.248Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.651 159.489h-11.332c-.607-.516.42-1.687 1.493-1.766.467-.035 1.056.062 1.73.205.156-2.073 1.046-11.398 4.403-11.023 3.773.419 0 4.106-1.067 6.289-.79 1.617-1.624 3.935-2.005 5.029.306.066.624.132.947.191.501-1.537 2.362-6.711 4.729-6.41 2.779.354 1.661 2.427-.308 3.659-1.445.905-3.219 2.192-4.063 2.814.715.116 1.46.195 2.216.178 1.941-.047 2.889.526 3.257.835v-.001ZM177.893 159.112c-.45-.708-1.805-2.545-3.608-2.302-1.966.265 2.171 1.563 3.437 2.307-.281.004-.523-.018-.701-.081-.847-.303-2.296.277-2.761.481h8.061a1.278 1.278 0 0 0-.577-.739c-.132-.08-.398-.092-.742-.066.48-.566.813-2.373-.522-1.908-.975.34-.972 1.444-.876 2.097-.208.033-.418.066-.626.096-.401-2.048-1.821-8.051-4.697-8.211-2.917-.163 2.473 6.225 4.268 8.268a8.709 8.709 0 0 1-.657.058h.001Z",
    fill: "#82B378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.818 108.131c4.533-4.54 4.533-11.9 0-16.439-4.533-4.54-11.882-4.54-16.415 0-4.533 4.54-4.533 11.899 0 16.439 4.533 4.539 11.882 4.539 16.415 0Z",
    fill: "#E2810E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.957 103.36c1.629-6.209-2.077-12.564-8.277-14.196-6.2-1.63-12.547 2.08-14.176 8.289-1.629 6.209 2.077 12.564 8.277 14.196 6.2 1.631 12.547-2.08 14.176-8.289Z",
    fill: "#FFB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.808 111.11a10.58 10.58 0 0 1-9.279-5.477 10.527 10.527 0 0 1-.897-8.055 10.517 10.517 0 0 1 5.053-6.332 10.496 10.496 0 0 1 8.045-.899 10.506 10.506 0 0 1 6.322 5.06c2.816 5.115.951 11.569-4.155 14.388a10.501 10.501 0 0 1-5.088 1.314l-.001.001Zm-.032-20.552a9.874 9.874 0 0 0-4.786 1.242 9.895 9.895 0 0 0-4.753 5.954 9.908 9.908 0 0 0 .844 7.575 9.951 9.951 0 0 0 8.726 5.15 9.883 9.883 0 0 0 4.784-1.235c4.802-2.652 6.555-8.721 3.907-13.529a9.882 9.882 0 0 0-5.945-4.76 9.989 9.989 0 0 0-2.778-.396h.001Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.547 102.509a1.753 1.753 0 0 0-.318-.526 1.282 1.282 0 0 0-.474-.322 2.377 2.377 0 0 0-.675-.15 6.311 6.311 0 0 0-.922-.007c-.611.03-1.176.03-1.696.003a5.287 5.287 0 0 1-1.41-.257 3.095 3.095 0 0 1-1.107-.649c-.318-.29-.577-.684-.779-1.181a3.182 3.182 0 0 1-.249-1.273c.009-.417.101-.815.277-1.194.177-.38.43-.732.759-1.058a4.876 4.876 0 0 1 1.201-.856l-.66-1.628 1.308-.532.67 1.65c.493-.129.969-.178 1.427-.146.458.033.881.144 1.27.335.389.19.738.461 1.048.811.31.35.569.779.774 1.286l-2.364.961c-.247-.609-.567-1.009-.96-1.201-.392-.192-.814-.197-1.267-.013-.246.1-.443.22-.593.361-.149.14-.257.293-.324.46a1.21 1.21 0 0 0-.082.525c.011.184.055.37.131.558.076.188.172.347.288.477.116.13.267.233.454.308.186.075.412.124.68.149.267.024.589.03.965.019.609-.017 1.174-.01 1.691.022.518.031.988.12 1.408.265.421.145.791.363 1.109.653.318.291.576.682.776 1.174.181.447.265.879.254 1.297a2.915 2.915 0 0 1-.285 1.189 3.55 3.55 0 0 1-.773 1.041c-.337.32-.742.603-1.215.848l.615 1.515-1.301.529-.611-1.508a5.866 5.866 0 0 1-1.433.237 3.753 3.753 0 0 1-1.392-.2 3.365 3.365 0 0 1-1.225-.765c-.373-.357-.683-.839-.93-1.448l2.364-.962c.147.36.319.641.517.841.199.199.412.338.64.414.227.076.461.099.7.069.239-.029.47-.09.694-.18a2.28 2.28 0 0 0 .635-.374c.167-.145.292-.302.375-.472a1.19 1.19 0 0 0 .126-.534c0-.187-.037-.374-.113-.562l.002.001Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.273 93.656c-.486-.344-1.587-1.1-1.644-.931-.041.121.018.327.149.54-.666-.248-1.343-.411-2.941-.104a1.199 1.199 0 0 0-.787.518c-.163.254-.223.573.184.826.817.509.58.204 1.715.944 1.134.74 2.523.929 3.352.41l1.113-.186.138-1.834s-.634-.076-1.278-.183h-.001ZM289.451 78.273s-2.625 3.119-5.967 1.815c0 0-.72-1.742-.73-3.026 0-.157-.003-.311-.005-.457-.018-1.445-.066-2.256-.066-2.256h.003c.152-.064 5.11-2.103 5.106-1.933-.085 3.91 1.66 5.859 1.66 5.859l-.001-.002Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.294 73.347c-.478.888-2.119 2.623-4.545 3.257-.018-1.445-.066-2.256-.066-2.256h.003c.137-.037 4.751-1.263 4.608-1v-.001Z",
    fill: "#ED975D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.644 74.197s5.576 1.313 6.339-2.177c.763-3.49 1.996-5.67-1.532-6.656-3.528-.986-4.513.194-5.05 1.297-.538 1.103-1.188 7.105.243 7.536Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.791 72.97c.076.05 1.275.419 3.547-4.114.357-.712.6-2.25-.231-3.61-.832-1.36-3.78-2.43-6.229-2.895-2.45-.466-3.038.914-3.614 2.301-.606 1.457-2.355 2.655-2.355 2.655 2.112 1.181 4.657-.509 5.537-.23.882.278 1.193 1.668 1.259 2.114.066.445.168.816 1.276.418 1.108-.398.501 1.572.324 1.95 0 0-.151 1.003.485 1.41l.001.002Z",
    fill: "#A9453D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.155 160h3.377c.708 0 1.494-.71 1.69-2.009.197-1.3 1.652-2.009 1.967-3.073.315-1.064-1.298-2.56-1.298-2.56l-.27-.347-.28-.362-2.674.63s-.066.638-.108 1.45a18.58 18.58 0 0 0-.01 1.859c.078 1.418-.397 2.945-1.654 3.221-1.259.276-.738 1.191-.738 1.191h-.002ZM278.651 160h8.95a.787.787 0 0 0 .189-.055c.598-.3.411-2.59.339-3.298a10.252 10.252 0 0 0-.024-.208s-3.147-2.52-3.58-.59c-.013.06-.03.12-.046.178-.546 1.807-2.988 2.627-4.399 2.856-1.077.175-1.357.804-1.429 1.119V160Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.455 108.318s.478 5.971 1.04 13.149c.764 9.751 1.682 21.727 1.772 23.997.158 3.94.788 10.242.788 10.242s1.493 1.497 4.484.866c0 0 2.664-8.997 3.426-18.516l.035-.47c.708-9.691 1.81-30.096 1.81-30.096l-13.354.827-.001.001Z",
    fill: "#2B478B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.455 108.318s.478 5.971 1.04 13.149l10.47 16.59.035-.471c.708-9.69 1.81-30.095 1.81-30.095l-13.354.827h-.001Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.638 109.027s8.614 21.626 14.279 31.789c5.664 10.162 7.434 12.999 7.434 12.999s3.245-1.3 3.541-2.187c0 0-2.166-19.62-5.96-24.402-2.143-2.703-4.661-10.813-4.779-13.649-.118-2.837-.767-8.45-.767-8.45l-13.747 3.9h-.001Z",
    fill: "#2B478B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.281 105.097.092 1.391s-.916 2.471 1.65 3.738c0 0 1.099.444 1.143-.413.045-.856-.096-.534-.006-1.74.089-1.206-.384-2.345-1.181-2.729l-.654-.755-1.043.508h-.001Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.286 106.111c-.954.306-1.107.236-1.107.236s-4.641-8.461-5.111-9.236c-.469-.774-9.853-9.488-9.853-9.488l2.412-9.005s10.672 13.84 11.825 15.826c1.905 3.282 3.02 10.903 3.02 10.903s-.436.522-1.186.763v.001Z",
    fill: "#1E3D70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.636 91.159a122.429 122.429 0 0 0 .313 6.416c.092 1.308.193 2.619.308 3.897.046.513.095 1.02.147 1.517l.008.067c.004.186.027.388.048.572.47 4.789.963 8.573 1.055 8.631a.54.54 0 0 0 .367.094c1.254-.158 4.996.127 8.059-.541 2.585-.545 4.811-1.581 7.169-2.977.313-.185 1.027-.676.969-1.043a49.956 49.956 0 0 0-.296-1.718c-.465-2.547-1.267-6.928-1.541-12.056a53.505 53.505 0 0 0-.232-2.826c-.263-2.416-.683-4.71-1.249-6.749-1.05-3.787-2.593-6.687-4.529-7.822-.253-.142-1.614.726-2.865 1.53-1.155.74-2.37.945-3.553.842l-1.04 1.152c-1.26 1.467-2.602 3.42-2.968 6.195a13.43 13.43 0 0 0-.071.654c-.102 1.13-.126 2.563-.098 4.165h-.001Z",
    fill: "#2A4E96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.636 91.159a121.217 121.217 0 0 0 .312 6.416c7.164-4.49 8.267-12.707 8.267-12.707-3.525.155-6.324.967-8.481 2.127-.102 1.13-.126 2.562-.098 4.165v-.001Z",
    fill: "#1E3D70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.538 94.695c-.073-1.064.476-1.24.476-1.24s10.8-1.96 11.718-2.25c.918-.29 8.769-8.467 8.769-8.467s3.009-3.398 5.473-2.648c2.141.652 2.978 2.324 3.263 3.918a4.697 4.697 0 0 1-2.177 4.818c-3.686 2.264-11.065 6.724-12.802 7.234-3.868 1.135-14.26.092-14.26.092s-.403-.62-.462-1.456h.002Z",
    fill: "#2A4E96"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M273.246 115.469v40.2c0 2.345-1.916 4.265-4.258 4.265h-41.265a4.354 4.354 0 0 1-2.93-1.143 4.408 4.408 0 0 1-.97-1.286 4.309 4.309 0 0 1-.452-1.929v-39.848a6.6 6.6 0 0 1 3.062-5.554l.005-.002a5.702 5.702 0 0 0 2.365-6.526h39.009a5.705 5.705 0 0 0-.263 1.718 5.7 5.7 0 0 0 2.436 4.678h.002c.098.069.198.135.301.197a6.136 6.136 0 0 1 2.957 5.232l.001-.002Z",
    fill: "#ED9F4A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M273.246 115.469v40.201a4.274 4.274 0 0 1-4.257 4.263h-18.17c-2.394 0-4.352-1.962-4.352-4.358v-39.848a6.597 6.597 0 0 1 3.061-5.554 5.7 5.7 0 0 0 2.635-4.811 5.7 5.7 0 0 0-.263-1.718h15.913a5.7 5.7 0 0 0-.263 1.718 5.69 5.69 0 0 0 2.739 4.875 6.134 6.134 0 0 1 2.957 5.232Z",
    fill: "#ED9F4A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M269.986 110.04c-1.274-.764-6.794-3.472-20.831-3.357-16.079.132-22.52 3.386-22.717 3.487a5.7 5.7 0 0 0 2.629-4.807 5.7 5.7 0 0 0-.263-1.718h39.009a5.7 5.7 0 0 0-.263 1.718c0 1.936.963 3.647 2.436 4.678v-.001Z",
    fill: "#ED9F4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.696 103.362v1.824c0 .18-.147.326-.326.326h-40.125a.326.326 0 0 1-.326-.326v-1.824c0-.179.146-.326.326-.326h40.125c.179 0 .326.147.326.326Z",
    fill: "#2B478B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.696 103.362v1.824c0 .18-.146.326-.325.326h-15.188a.327.327 0 0 1-.327-.326v-1.824c0-.179.147-.326.327-.326h15.188c.179 0 .325.147.325.326Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.926 112.391s-1.035 1.457-1.982 1.478c-.948.02-2.391-.676-2.391-.676s-.871-1.943-.28-2.703c0 0 .591-.261 1.211.199.106.08.214.179.32.308.15.181.319.283.498.338.676.206 1.48-.279 1.78.189a3.2 3.2 0 0 0 .523.62c.186.166.321.247.321.247ZM228.443 122.907s3.655-8.869 10.235-9.038c0 0 6.073.676 6.411 9.038h-16.647.001Z",
    fill: "#F9DDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.876 114.14s2.637.587 3.451.242c0 0 .123-1.105-.987-.949-.76.106-1.256-.26-1.547-.409-.412-.21-1.027.654-.917 1.116Z",
    fill: "#F1A34F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.171 112.475c-.169.127-.687-1.786-.687-1.786.107.079.214.179.321.307.15.182.319.284.497.338.002.056.033 1.018-.131 1.14v.001ZM241.606 112.144c-.037.022-1.257.753-1.422.753-.164 0 .9-1.373.9-1.373a3.2 3.2 0 0 0 .523.62h-.001ZM232.014 120.43c-.068-.058 2.587-3.914 3.318-3.942.73-.028 2.373.845 3.563.958 1.189.112 2.342-.226 2.566.478.226.704.844 3.2.465 3.599-.38.399-8.452.156-9.912-1.093Z",
    fill: "#E5C1A1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M229.057 156.896a17.28 17.28 0 0 1-.639.319 17.043 17.043 0 0 1-3.627 1.576 4.408 4.408 0 0 1-.933-1.213c-.163.088-.325.171-.489.253V127.5c.752.1 1.496.25 2.225.448 4.092 1.107 7.736 3.714 9.952 7.549 4.403 7.619 1.497 17.2-6.489 21.4v-.001Z",
    fill: "#E2810E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.823 134.301c-4.403-7.998-14.446-10.907-22.433-6.498s-10.892 14.466-6.49 22.465c4.403 7.998 14.446 10.907 22.433 6.499 7.987-4.409 10.892-14.467 6.489-22.465l.001-.001Z",
    fill: "#E2810E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.693 157.101c-.203.125-.41.244-.62.361-.072.039-.143.078-.214.115-.164.088-.326.171-.49.253-7.863 3.867-17.455.899-21.729-6.866-4.078-7.407-1.887-16.581 4.804-21.399a16.798 16.798 0 0 1 2.954-1.697 16.212 16.212 0 0 1 1.967-.731 16.227 16.227 0 0 1 2.99-.604c3.111-.33 6.24.239 9.014 1.598a16.444 16.444 0 0 1 7.193 6.866c4.287 7.788 1.646 17.527-5.869 22.104Z",
    fill: "#FFB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.216 158.224c-1.404 0-2.816-.199-4.203-.6a14.943 14.943 0 0 1-8.994-7.199 14.981 14.981 0 0 1-1.277-11.46 14.962 14.962 0 0 1 7.189-9.007 14.93 14.93 0 0 1 11.445-1.279 14.949 14.949 0 0 1 8.995 7.2 14.984 14.984 0 0 1 1.276 11.46 14.955 14.955 0 0 1-7.189 9.007 14.95 14.95 0 0 1-7.241 1.879l-.001-.001Zm-12.412-8.233a14.061 14.061 0 0 0 8.459 6.77 14.035 14.035 0 0 0 10.761-1.202 14.074 14.074 0 0 0 6.76-8.471 14.089 14.089 0 0 0-1.2-10.776 14.061 14.061 0 0 0-8.459-6.77 14.04 14.04 0 0 0-10.761 1.202 14.071 14.071 0 0 0-6.76 8.471 14.089 14.089 0 0 0 1.2 10.776Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.473 144.591a5.164 5.164 0 0 0-.103-.238c-.268-.589-.601-1.067-1.002-1.433a4.461 4.461 0 0 0-1.577-.929 7.567 7.567 0 0 0-2.003-.377 27.278 27.278 0 0 0-2.406-.031c-.536.016-.994.006-1.374-.028a3.45 3.45 0 0 1-.968-.211 1.697 1.697 0 0 1-.645-.439 2.291 2.291 0 0 1-.411-.677 2.521 2.521 0 0 1-.186-.795 1.719 1.719 0 0 1 .117-.748c.094-.235.248-.453.46-.653.213-.201.493-.371.842-.514.645-.262 1.246-.256 1.804.017.558.274 1.013.844 1.364 1.71l3.364-1.368c-.293-.722-.659-1.331-1.101-1.829a4.818 4.818 0 0 0-1.491-1.153 4.858 4.858 0 0 0-1.807-.477 6.251 6.251 0 0 0-2.031.208l-.953-2.349-1.862.756.939 2.318a7 7 0 0 0-1.709 1.218 5.257 5.257 0 0 0-1.078 1.504 4.19 4.19 0 0 0-.395 1.7 4.538 4.538 0 0 0 .354 1.81c.287.707.656 1.268 1.109 1.681.452.413.977.721 1.574.923a7.436 7.436 0 0 0 2.005.364c.739.041 1.544.04 2.412-.002a8.8 8.8 0 0 1 1.312.009c.371.034.692.105.962.214s.494.261.673.457c.18.197.331.447.453.749.109.268.163.533.161.799 0 .265-.06.519-.18.761a2.158 2.158 0 0 1-.534.672 3.264 3.264 0 0 1-.904.531 3.879 3.879 0 0 1-.987.256c-.34.042-.672.008-.997-.099a2.31 2.31 0 0 1-.909-.589c-.283-.284-.528-.682-.735-1.195l-3.364 1.368c.35.866.792 1.553 1.323 2.06.531.507 1.112.87 1.743 1.088a5.351 5.351 0 0 0 1.981.286 8.382 8.382 0 0 0 2.04-.337l.868 2.144 1.851-.753-.874-2.153a7.525 7.525 0 0 0 1.727-1.208 5.11 5.11 0 0 0 1.043-1.363l.059-.119a4.152 4.152 0 0 0 .405-1.69c.016-.595-.104-1.211-.362-1.845l.003-.001Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.833 84.764c.051-.203-4.397 2.013-4.624 2.264-2.086 2.317-1.491 5.342-.297 5.371.765.019.617 1.294.617 1.294l8.53-3.614s-1.027-5.997-4.226-5.314v-.001Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.883 85.232s.305-3.327-3.408-3.327c0 0 1.125.306 1.707.917 0 0-2.368-1.392-4.945.747-2.577 2.14-.975 7.504-1.759 8.523-.783 1.019-3.835 1.222-3.462 4.516.373 3.293 9.685 7.418 9.086 10.144 0 0 3.65-5.372 1.04-7.824 0 0 1.272 1.2 1.402 2.626 0 0 .346-2.784-1.424-3.675-1.566-.788-2.849-3.67-2.712-4.185.135-.515 4.475-8.46 4.475-8.46v-.002Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.512 100.886c-.573-2.76-4.147-3.616-5.839-1.362a2.982 2.982 0 0 0-.587 1.45c-.386 3.134 4.617 15.898 5.333 17.053 1.305 2.104 8.986 9.317 8.986 9.317l1.415-.859s-5.448-9.237-6.292-10.101c-.975-1-1.93-10.256-3.017-15.498h.001Z",
    fill: "#ED985F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.867 126.489s2.066-1.358 2.849-1.271c.782.087 3.046.74 3.074 1.073.027.333-2.523.541-2.694.723-.171.182-1.903 1.34-2.53.977-.628-.363-.698-1.502-.698-1.502h-.001Z",
    fill: "#ED985F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194.454 157.181-1.846-.271s-6.207-4.939-7.13-14.156a16.498 16.498 0 0 1-.045-2.849.5.5 0 0 0-.064-.314s0-.002-.003-.003a105.21 105.21 0 0 1-1.362-2.155c-.66-1.071-1.789-3.095-3.031-5.365-2.238-4.09-4.843-8.981-5.737-10.538-2.847-4.964-1.475-8.303-1.475-8.303s7.944-.787 10.12-2.693l.784 1.21s1.722 7.631 1.64 7.666l.259.793c1.358 4.197 2.92 9.445 3.772 13.718.479 2.405.732 4.5.596 5.927-.047.49.009 1.242.14 2.171.769 5.476 3.382 15.162 3.382 15.162Z",
    fill: "#2B478B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.326 159.52h-7.701s-.185-1.176.218-2.067c.385-.855.935-.883.071-2.224.489.504 2.062.713 3.175.563.137.222.879 1.708 1.336 2.035.503.363 2.747.233 2.902 1.693h-.001ZM186.564 120.202c-.673 3.715-2.262 9.898-5.591 11.866-2.238-4.09-4.843-8.981-5.737-10.538-2.847-4.964-1.475-8.303-1.475-8.303s7.944-.787 10.12-2.693l.784 1.21s1.722 7.631 1.64 7.666l.259.793v-.001Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.688 99.174s1.089 1.133 1.586 2.492c0 0-1.737 4.995-5.796 5.621 0 0 3.211-8.116 4.209-8.113h.001Z",
    fill: "#ED7D2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.163 113.8.026-1.442c-2.869.362-9.895-3.434-9.895-3.434s-3.002 2-3.413 7.71c-.2 2.787-1.469 14.575-1.61 18.095-.05 1.276-.067 2.186-.074 2.55v.003a.5.5 0 0 1-.122.297 16.6 16.6 0 0 0-1.555 2.387c-4.378 8.158-2.089 19.244-2.089 19.244l1.017-.259s3.703-11.492 6.123-16.463c.411-.843.784-1.499 1.095-1.878.91-1.107 1.869-2.986 2.815-5.247 1.787-4.277 3.523-9.919 4.76-14.288.088.016 2.921-7.274 2.921-7.274l.001-.001Z",
    fill: "#2B478B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.957 104.174c-4.691-1.078-1.694-7.68-1.423-7.563.65-.133 2.077-1.276 3.355-3.508l.173.15 2.88 2.53s-.666.984-1.226 1.948c-.438.754-.81 1.498-.751 1.753.232.182-1.758 4.979-3.009 4.691l.001-.001Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.943 95.784s-.666.982-1.227 1.948c-1.791-1.106-1.793-3.327-1.655-4.477l2.882 2.53v-.001Z",
    fill: "#ED985F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.023 97.05s-4.35-2.423-2.801-5.112c1.549-2.69 2.031-4.814 4.874-3.38 2.842 1.433 2.786 2.77 2.487 3.792-.299 1.024-3.389 5.261-4.56 4.7Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.317 90.782c-.199-1.194-.805-1.308-1.227-1.228-1.607-2.66-4.231-1.622-4.231-1.622-1.402 1.762-3.428 2.062-3.428 2.062s.504.94 2.584 1.522c.636.178 1.357.07 2.052-.164a11.614 11.614 0 0 1-2.952 1.114c2.74.252 5.348-2.257 5.619-2.526.126.39.348 1.204.215 1.799-.18.808-.897 2.273-.459 2.462 0 0 2.126-1.628 1.827-3.419Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.557 159.52h-7.701s-.185-1.176.218-2.067c.385-.855.989-1.244.844-2.28.49.504 1.287 1.07 2.401.919.136.222.881 1.407 1.336 1.734.503.363 2.748.233 2.903 1.693l-.001.001Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.509 109.408c-.991.346-2.382.536-3.805.69-2.025.222-4.115.373-5.211.81-.4.16-.667.357-.75.608-.475 1.43-2.567 3.636-2.567 3.636-13.409-.612-14.881-6.229-14.881-6.229 9.022-10.505 24.297-13.546 24.297-13.546s1.091-.463 3.839 1.724c1.833 1.46 1.592 2.02 1.592 2.02s.4 9.268-2.515 10.287h.001Z",
    fill: "#F99746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.704 110.098c-2.025.222-4.116.373-5.211.81-.448-6.697 2.708-11.734 2.708-11.734s2.059 8.39 2.503 10.924Z",
    fill: "#ED7D2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.788 97.878s-5.075.502-5.481 3.804c-.407 3.302 4.865 16.752 5.62 17.971 1.375 2.217 9.469 9.817 9.469 9.817l1.492-.905s-5.741-9.734-6.63-10.645c-1.395-1.43-2.751-18.898-4.469-20.042h-.001Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.452 103.669c.013.075 4.684 1.528 7.689 0 0 0 .643-6.944-2.946-6.567-3.588.376-5.713 1.508-5.803 3.229-.091 1.72 1.059 3.338 1.059 3.338h.001Z",
    fill: "#F99746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.936 128.505s1.82-1.675 2.606-1.714c.786-.04 3.125.238 3.206.562.081.325-2.402.942-2.542 1.149-.139.208-1.662 1.63-2.34 1.372-.678-.257-.93-1.369-.93-1.369Z",
    fill: "#FFB27D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Discover_Home_Banner_Native_svg__c",
    x1: 50.214,
    y1: -70.01,
    x2: 50.214,
    y2: 217.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Discover_Home_Banner_Native_svg__d",
    x1: 53.596,
    y1: -71.64,
    x2: 53.596,
    y2: 215.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Discover_Home_Banner_Native_svg__e",
    x1: 56.979,
    y1: -73.27,
    x2: 56.979,
    y2: 213.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Discover_Home_Banner_Native_svg__f",
    x1: 60.361,
    y1: -74.9,
    x2: 60.361,
    y2: 212.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Discover_Home_Banner_Native_svg__g",
    x1: 63.747,
    y1: -76.533,
    x2: 63.747,
    y2: 210.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Discover_Home_Banner_Native_svg__h",
    x1: 67.129,
    y1: -78.163,
    x2: 67.129,
    y2: 208.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Discover_Home_Banner_Native_svg__i",
    x1: 70.512,
    y1: -79.793,
    x2: 70.512,
    y2: 207.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Discover_Home_Banner_Native_svg__j",
    x1: 73.895,
    y1: -72.759,
    x2: 73.895,
    y2: 205.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Discover_Home_Banner_Native_svg__k",
    x1: 77.278,
    y1: -74.9,
    x2: 77.278,
    y2: 204.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Discover_Home_Banner_Native_svg__l",
    x1: 80.659,
    y1: -69.494,
    x2: 80.659,
    y2: 202.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Discover_Home_Banner_Native_svg__w",
    x1: 237.686,
    y1: -10.343,
    x2: 284.708,
    y2: 203.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAD9ED"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Home_Banner_Native_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(14.23 -118.648 -357.294) scale(571.833 282.968)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D7AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E304B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Home_Banner_Native_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.45685 -.104 .10407 1.45795 177.834 62.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Home_Banner_Native_svg__n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.40778 -.17188 .172 2.40958 196.616 50.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Home_Banner_Native_svg__o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.38372 -.09877 .09885 1.38475 341.882 101.224)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Home_Banner_Native_svg__p",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.28892 -.1634 .16351 2.29062 329.959 45.44)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Home_Banner_Native_svg__q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.40778 .17188 -.172 2.40958 165.341 18.544)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Home_Banner_Native_svg__r",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.40778 -.17188 .172 2.40957 165.291 37.624)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Home_Banner_Native_svg__s",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(4.8278 0 0 4.83144 30.184 100.739)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#ADADAD",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#636363",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#2D2D2D",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#0C0C0C",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Home_Banner_Native_svg__t",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(4.8278 0 0 4.83144 40.747 123.808)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#ADADAD",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#636363",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#2D2D2D",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#0C0C0C",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Home_Banner_Native_svg__u",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(4.8278 0 0 4.83143 25.209 125.383)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#D0D0D0",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#9F9F9F",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#757575",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#505050",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#333",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#1C1C1C",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#0C0C0C",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#020202",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Discover_Home_Banner_Native_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h343v160H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Discover_Home_Banner_Native_svg__v"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(139 50)",
    d: "M0 0h198v110H0z"
  })))));
};
export default SvgDiscoverHomeBannerNative;